import { UnitOfMeasureEnums } from "@finway-group/shared/lib/consts/lineItems"
import { type UserRule, type VendorRule } from "@finway-group/shared/lib/models"
import { type Address } from "@finway-group/shared/lib/models/company/address.interface"
import { type SelectProps } from "antd/lib/select"
import { type TFunction } from "i18next"
import { type FormSelectOption } from "~Components/form/form.types"

export type AccountingRule = {
    costCenter?: string
    costCenter2?: string
    expenseAccount?: string
}

export const calculateAccountingRules = ({
    vendorRule,
    userRule,
    vendorRulesShouldOverwrite,
}: {
    vendorRule?: Pick<VendorRule, "costCenter" | "costCenter2" | "expenseAccount">
    userRule?: Pick<UserRule, "costCenter" | "costCenter2" | "expenseAccount">
    vendorRulesShouldOverwrite: boolean
}): AccountingRule => {
    const primaryRule = vendorRulesShouldOverwrite ? vendorRule : userRule
    const secondaryRule = vendorRulesShouldOverwrite ? userRule : vendorRule
    return {
        costCenter: primaryRule?.costCenter ?? secondaryRule?.costCenter,
        costCenter2: primaryRule?.costCenter2 ?? secondaryRule?.costCenter2,
        expenseAccount: primaryRule?.expenseAccount ?? secondaryRule?.expenseAccount,
    }
}
export const formatAddress = (address?: Address): string => {
    if (!address) {
        return ""
    }

    const parts = [address.addressLine1, [address.zip, address.city].filter(Boolean).join(" "), address.country].filter(Boolean)

    return parts.join(", ")
}

const formatAddressFromString = (address?: string): Address => {
    if (!address) {
        return {
            addressLine1: "",
            addressLine2: "",
            zip: "",
            city: "",
            country: "",
        }
    }

    const splitAddress = address.split(",").map((part) => part.trim())

    const addressLine1 = splitAddress[0] || ""
    const city = splitAddress[1] || ""
    const country = splitAddress[2] || ""

    return {
        addressLine1,
        addressLine2: "",
        zip: "", // not supported (too many possible formats)
        city,
        country,
    }
}

export const formatDeliveryLocation = (address: string | Address | undefined): Address | undefined => (typeof address === "string" ? formatAddressFromString(address) : address)

export const getUnitOfMeasureOptions = (t: TFunction): Array<FormSelectOption> =>
    Object.values(UnitOfMeasureEnums)
        .map((enumValue) => ({
            param: t(`enum:UnitOfMeasureEnums.${enumValue}`),
            value: enumValue,
        }))
        .sort((a, b) => a.param.localeCompare(b.param))

export const searchByLabelFilterOption: SelectProps<string, FormSelectOption>["filterOption"] = (input: string, option: FormSelectOption) => {
    return option.label?.toLowerCase().includes(input.toLowerCase()) ?? false
}
